(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('TableauHeuresReellementEffectueesCtrl', TableauHeuresReellementEffectueesCtrl);

    TableauHeuresReellementEffectueesCtrl.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService'];

    function TableauHeuresReellementEffectueesCtrl ($scope, $state, ParseLinks, AlertService) {
        var vm = this;
    }
})();
